export default __webpack_public_path__ + "static/media/swimming.1f669ee7.gif";